// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    myActions: {
        id: 'actions-entry.my-actions',
        defaultMessage: 'My Actions'
    },
    discoverActions: {
        id: 'actions-entry.discover-actions',
        defaultMessage: 'Discover Actions'
    },
    sideModalTitle: {
        id: 'actions-entry.side-modal-title',
        defaultMessage: 'Personalise'
    },
    confirmRemoveAction: {
        id: 'actions-entry.confirm-remove-action',
        defaultMessage: 'Remove this action?'
    },
    removeActionButton: {
        id: 'actions-entry.remove-action-button',
        defaultMessage: 'Remove Action'
    },
    notFullySupportedTitle: {
        id: 'actions-entry.action-not-fully-supported-title',
        defaultMessage: 'This Action is no longer fully supported'
    },
    notFullySupportedContent: {
        id: 'actions-entry.action-not-fully-supported-content',
        defaultMessage: 'It will still work, but can no longer be edited. Create a new Action to edit'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/intl.js